<template>
  <div>
    <h1>Nova de Concedente_contato</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("concedentes_contatos", ["concedente_contato"]),
  },
  methods: {
    ...mapActions("concedentes_contatos", ["ActionNewConcedente_contato"]),
    loadData(id) {
      this.$router.push({
        name: "concedentes_contatos_edit",
        params: { id: id },
      });
    },
  },
  async created() {
    this.ActionNewConcedente_contato();
  },
};
</script>

<style></style>
